import { render, staticRenderFns } from "./loadingView.vue?vue&type=template&id=c0cbcf98&scoped=true&"
import script from "./loadingView.vue?vue&type=script&lang=ts&"
export * from "./loadingView.vue?vue&type=script&lang=ts&"
import style0 from "./loadingView.vue?vue&type=style&index=0&id=c0cbcf98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0cbcf98",
  null
  
)

export default component.exports